import { isObjectSort, Sort } from '../types/sort';
import { isIsoDate } from '../../functions/is-iso-date.function';
import moment from 'moment/moment';
import { getValue } from '../../functions/get-value.function';

export function sort<T>(items: T[], sort: Sort<T> | null | undefined): T[] {
  if(!sort)
    return items;

  return items.sort((f, s) => {
    const fValue = isObjectSort(sort) ? getValue(f, sort.property) : f;
    const sValue = isObjectSort(sort) ? getValue(s, sort.property) : s;
    let returnValue = (sort.comparator ?? defaultSortFn)(fValue, sValue);

    if(sort.direction === 'desc')
      returnValue *= -1;
    return returnValue;
  })
}

function defaultSortFn(f: any, s: any): number {
  if(isIsoDate(f) && isIsoDate(s)) {
    const fDate = moment(f, false);
    const sDate = moment(f, false);
    if(fDate.isValid() && sDate.isValid())
      return fDate.isAfter(s) ? 1 : (fDate.isBefore(s) ? -1 : 0)
  }
  return f > s ? 1 : (f < s ? -1 : 0)
}
